import {Inject, Injectable} from "@angular/core";
import {
    ActionService,
    collection,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {OrderItemData} from "./order-initiation.service";
import {OrderType} from "./order";

export class AvailableOrderTimesRequestData extends EntityData<AvailableOrderTimesRequestData> {
    @field expectedCompletion: string;
    @field orderType: string;
    @field allowCarryOverTimes: boolean;
    @collection(OrderItemData) items: OrderItemData[];

    public set orderTypeEnum(orderType: OrderType) {
        this.orderType = OrderType.toString(orderType);
    }
}

export class AvailableOrderTimeData extends EntityData<AvailableOrderTimeData> {
    @field time: string;
    @field carryOver: boolean;
    @field available: boolean;
    @field unavailabilityReason: string;
}

export class AvailableOrderTimesGroupData extends EntityData<AvailableOrderTimesGroupData> {
    @collection(AvailableOrderTimeData) specificTimes: AvailableOrderTimeData[];
}

export class AvailableOrderTimesResponseData extends EntityData<AvailableOrderTimesResponseData> {
    @collection(AvailableOrderTimesGroupData) specificTimeGroups: AvailableOrderTimesGroupData[];
}

@Injectable()
export class AvailableOrderTimesService extends ActionService {
    constructor(http: JwtHttpClientService, configService: ConfigurationService, @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace, @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "available-order-times");
    }
}



// WEBPACK FOOTER //
// ./src/app/order/available-order-times.service.ts